// components/TextInput.tsx
import { useFormContext } from 'react-hook-form';

import type { FormOptions, GeneralFormProps } from '@/types/general';

import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormMessage,
} from '../ui/form';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../ui/select';

type Props<T extends string> = {
  options: FormOptions;
  value?: T;
  onChange?: (value: T) => void;
} & GeneralFormProps;

function RHFShadcnSelect<T extends string>({
  name,
  options,
  placeholder,
  title,
  description,
  value: externalValue,
  onChange: externalOnChange,
  required,
  disabled,
}: Props<T>) {
  const { control } = useFormContext();

  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem className="mt-4 w-full">
          <FormControl>
            <Select
              disabled={disabled}
              required={required}
              data-testid={field.name}
              onValueChange={(value) => {
                if (externalOnChange !== null && externalOnChange !== undefined) {
                  externalOnChange(value);
                }
                field.onChange(value);
              }}
              value={field.value || externalValue}
            >
              <FormControl>
                <SelectTrigger title={title}>
                  <SelectValue placeholder={placeholder} />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                {options.map(item => (
                  <SelectItem key={item.value} value={item.value}>
                    <p>{item.label}</p>
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </FormControl>
          {description !== null && description !== undefined && description !== '' && <FormDescription>{description}</FormDescription>}
          <FormMessage />
        </FormItem>
      )}
    />
  );
}

export default RHFShadcnSelect;
